import { SET_AUTH } from "./type";

// eslint-disable-next-line import/no-anonymous-default-export
export default (auth:any = null, { type, payload }: {type: any, payload:any}) => {
  switch (type) {
    case SET_AUTH:
      return payload

    default:
      return auth;
  }
};

